// Hala Beauty: standalone T4S integration; no reference-theme imports.

// Prevent the legacy EasySell cart pairing from mounting when this replacement is active.
window.__btCartDesktopPaymentPair = true;

const LEAFLET_VERSION = '1.9.4';
const LEAFLET_JS = `https://cdn.jsdelivr.net/npm/leaflet@${LEAFLET_VERSION}/dist/leaflet.js`;
const LEAFLET_CSS = `https://cdn.jsdelivr.net/npm/leaflet@${LEAFLET_VERSION}/dist/leaflet.css`;
const OMAN_CENTER = [21.4735, 55.9754];

const OMAN_WILAYAS = [
  {
    ar: 'محافظة مسقط', en: 'Muscat Governorate', items: [
      ['muscat', 'مسقط', 'Muscat'], ['muttrah', 'مطرح', 'Muttrah'],
      ['al_amerat', 'العامرات', 'Al Amerat'], ['bawshar', 'بوشر', 'Bawshar'],
      ['seeb', 'السيب', 'Seeb'], ['qurayyat', 'قريات', 'Qurayyat']
    ]
  },
  {
    ar: 'محافظة ظفار', en: 'Dhofar Governorate', items: [
      ['salalah', 'صلالة', 'Salalah'], ['taqah', 'طاقة', 'Taqah'],
      ['mirbat', 'مرباط', 'Mirbat'], ['rakhyut', 'رخيوت', 'Rakhyut'],
      ['thumrait', 'ثمريت', 'Thumrait'], ['dhalkut', 'ضلكوت', 'Dhalkut'],
      ['al_mazyunah', 'المزيونة', 'Al Mazyunah'], ['muqshin', 'مقشن', 'Muqshin'],
      ['shalim_hallaniyat', 'شليم وجزر الحلانيات', 'Shalim and the Hallaniyat Islands'],
      ['sadah', 'سدح', 'Sadah']
    ]
  },
  {
    ar: 'محافظة مسندم', en: 'Musandam Governorate', items: [
      ['khasab', 'خصب', 'Khasab'], ['dibba', 'دبا', 'Dibba'],
      ['bukha', 'بخاء', 'Bukha'], ['madha', 'مدحاء', 'Madha']
    ]
  },
  {
    ar: 'محافظة البريمي', en: 'Al Buraimi Governorate', items: [
      ['al_buraimi', 'البريمي', 'Al Buraimi'], ['mahdah', 'محضة', 'Mahdah'],
      ['al_sunaynah', 'السنينة', 'Al Sunaynah']
    ]
  },
  {
    ar: 'محافظة الداخلية', en: 'Ad Dakhiliyah Governorate', items: [
      ['nizwa', 'نزوى', 'Nizwa'], ['bahla', 'بهلاء', 'Bahla'],
      ['manah', 'منح', 'Manah'], ['al_hamra', 'الحمراء', 'Al Hamra'],
      ['adam', 'أدم', 'Adam'], ['izki', 'إزكي', 'Izki'],
      ['samail', 'سمائل', 'Samail'], ['bidbid', 'بدبد', 'Bidbid'],
      ['jabal_al_akhdar', 'الجبل الأخضر', 'Jabal Al Akhdar']
    ]
  },
  {
    ar: 'محافظة شمال الباطنة', en: 'North Al Batinah Governorate', items: [
      ['sohar', 'صحار', 'Sohar'], ['shinas', 'شناص', 'Shinas'],
      ['liwa', 'لوى', 'Liwa'], ['saham', 'صحم', 'Saham'],
      ['al_khaburah', 'الخابورة', 'Al Khaburah'], ['al_suwaiq', 'السويق', 'Al Suwaiq']
    ]
  },
  {
    ar: 'محافظة جنوب الباطنة', en: 'South Al Batinah Governorate', items: [
      ['al_rustaq', 'الرستاق', 'Al Rustaq'], ['al_awabi', 'العوابي', 'Al Awabi'],
      ['nakhal', 'نخل', 'Nakhal'], ['wadi_al_maawil', 'وادي المعاول', 'Wadi Al Maawil'],
      ['barka', 'بركاء', 'Barka'], ['al_musannah', 'المصنعة', 'Al Musannah']
    ]
  },
  {
    ar: 'محافظة جنوب الشرقية', en: 'South Ash Sharqiyah Governorate', items: [
      ['sur', 'صور', 'Sur'], ['al_kamil_wal_wafi', 'الكامل والوافي', 'Al Kamil Wal Wafi'],
      ['jalan_bani_bu_hassan', 'جعلان بني بو حسن', 'Jalan Bani Bu Hassan'],
      ['jalan_bani_bu_ali', 'جعلان بني بو علي', 'Jalan Bani Bu Ali'],
      ['masirah', 'مصيرة', 'Masirah']
    ]
  },
  {
    ar: 'محافظة شمال الشرقية', en: 'North Ash Sharqiyah Governorate', items: [
      ['ibra', 'إبراء', 'Ibra'], ['al_mudhaibi', 'المضيبي', 'Al Mudhaibi'],
      ['bidiyah', 'بدية', 'Bidiyah'], ['al_qabil', 'القابل', 'Al Qabil'],
      ['wadi_bani_khalid', 'وادي بني خالد', 'Wadi Bani Khalid'],
      ['dima_wattayeen', 'دماء الطائيين', 'Dima Wattayeen'],
      ['sinaw', 'سناو', 'Sinaw']
    ]
  },
  {
    ar: 'محافظة الظاهرة', en: 'Ad Dhahirah Governorate', items: [
      ['ibri', 'عبري', 'Ibri'], ['yanqul', 'ينقل', 'Yanqul'], ['dhank', 'ضنك', 'Dhank']
    ]
  },
  {
    ar: 'محافظة الوسطى', en: 'Al Wusta Governorate', items: [
      ['haima', 'هيماء', 'Haima'], ['mahout', 'محوت', 'Mahout'],
      ['duqm', 'الدقم', 'Duqm'], ['al_jazir', 'الجازر', 'Al Jazir']
    ]
  }
];

function normalizeDigits(value) {
  const arabic = '٠١٢٣٤٥٦٧٨٩';
  const persian = '۰۱۲۳۴۵۶۷۸۹';
  return String(value || '').replace(/[٠-٩۰-۹]/g, (digit) => {
    const arabicIndex = arabic.indexOf(digit);
    return String(arabicIndex > -1 ? arabicIndex : persian.indexOf(digit));
  });
}

function normalizeOmanPhone(value) {
  let digits = normalizeDigits(value).replace(/\D/g, '');
  if (digits.startsWith('00968')) digits = digits.slice(5);
  else if (digits.startsWith('968')) digits = digits.slice(3);
  return /^[79]\d{7}$/.test(digits) ? digits : '';
}

function makeIdempotencyKey() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID();
  }
  return `bt-cod-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function safeJson(text) {
  try { return JSON.parse(text); } catch (_) { return null; }
}

function normalizeMoneyDecimal(value) {
  const match = /^(\d+)(?:\.(\d{1,3}))?$/.exec(String(value ?? '').trim());
  if (!match) return '';
  return `${match[1]}.${String(match[2] || '').padEnd(3, '0')}`;
}

function normalizePlaceName(value) {
  return String(value || '')
    .normalize('NFKD')
    .replace(/[\u064B-\u065F\u0670\u06D6-\u06ED]/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ى/g, 'ي')
    .replace(/ة/g, 'ه')
    .trim()
    .toLowerCase()
    .replace(/\b(?:wilayat|wilaya|province|governorate)\b/g, ' ')
    .replace(/\b(?:of|the)\b/g, ' ')
    .replace(/\b(?:al|a)\b/g, ' ')
    .replace(/(?:ولاية|محافظة)/g, ' ')
    .replace(/[^\p{L}\p{N}]+/gu, '')
    .trim();
}

function findWilaya(value) {
  const wanted = normalizePlaceName(value);
  if (!wanted) return null;
  for (const governorate of OMAN_WILAYAS) {
    for (const [code, ar, en] of governorate.items) {
      const candidates = [code, ar, en].map(normalizePlaceName);
      if (candidates.includes(wanted)) return { code, ar, en };
    }
  }
  return null;
}

function findWilayaCode(value) {
  return findWilaya(value)?.code || '';
}

function manualWilayaRecord(value) {
  const text = String(value || '').trim();
  return text.length >= 2 && text.length <= 80 && /\p{L}/u.test(text)
    ? { code: text, ar: text, en: text, manual: text }
    : null;
}

function stripOmanCountry(value, separator = ', ') {
  const countryNames = new Set([
    normalizePlaceName('Oman'),
    normalizePlaceName('Sultanate of Oman'),
    normalizePlaceName('\u0639\u0645\u0627\u0646'),
    normalizePlaceName('\u0633\u0644\u0637\u0646\u0629 \u0639\u0645\u0627\u0646')
  ]);
  return String(value || '')
    .split(/[,،\n]+/u)
    .map((part) => part.trim())
    .filter((part) => part && !countryNames.has(normalizePlaceName(part)))
    .join(separator)
    .replace(/\s{2,}/g, ' ')
    .trim();
}

function wilayaFromAddress(value) {
  const address = stripOmanCountry(value);
  const normalizedAddress = normalizePlaceName(address);
  if (!normalizedAddress) return null;

  for (const governorate of OMAN_WILAYAS) {
    for (const [code, ar, en] of governorate.items) {
      const candidates = [code, ar, en].map(normalizePlaceName).filter(Boolean);
      if (candidates.some((candidate) => normalizedAddress.includes(candidate))) {
        return { code, ar, en };
      }
    }
  }

  const firstPart = address.split(/[,،\n]+/u).map((part) => part.trim()).find(Boolean) || address;
  return manualWilayaRecord(firstPart.slice(0, 80));
}

function couponComparisonKey(value) {
  return String(value || '').trim().toLocaleLowerCase('en-US');
}

function isSafariBrowser() {
  const userAgent = String(navigator.userAgent || '');
  return /Safari/i.test(userAgent) &&
    !/(?:Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/i.test(userAgent);
}

function loadLeaflet() {
  if (window.L && typeof window.L.map === 'function') return Promise.resolve(window.L);
  if (window.__btCodLeafletPromise) return window.__btCodLeafletPromise;

  window.__btCodLeafletPromise = new Promise((resolve, reject) => {
    if (!document.getElementById('bt-cod-leaflet-css')) {
      const link = document.createElement('link');
      link.id = 'bt-cod-leaflet-css';
      link.rel = 'stylesheet';
      link.href = LEAFLET_CSS;
      link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    }

    const existing = document.getElementById('bt-cod-leaflet-js');
    const script = existing || document.createElement('script');
    if (!existing) {
      script.id = 'bt-cod-leaflet-js';
      script.src = LEAFLET_JS;
      script.crossOrigin = 'anonymous';
      script.defer = true;
      document.head.appendChild(script);
    }

    const done = () => {
      if (window.L && typeof window.L.map === 'function') resolve(window.L);
      else reject(new Error('LEAFLET_UNAVAILABLE'));
    };
    script.addEventListener('load', done, { once: true });
    script.addEventListener('error', () => reject(new Error('LEAFLET_LOAD_FAILED')), { once: true });
    if (existing && window.L) done();
  });

  return window.__btCodLeafletPromise;
}

class BtCodForm extends HTMLElement {
  connectedCallback() {
    if (this.dataset.btReady === '1') return;
    this.dataset.btReady = '1';
    this.abortController = new AbortController();
    this.requestControllers = new Set();
    this.clockAnimations = new Map();
    this.clockLoaders = new Map();
    this.prefersReducedMotion = Boolean(
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
    this.state = {
      eligible: false,
      eligibilityToken: '',
      eligibilityExpiresAt: 0,
      eligibilityCountry: '',
      open: false,
      opening: false,
      submitting: false,
      completed: false,
      cart: null,
      quote: null,
      quoteToken: '',
      appliedCoupon: '',
      phoneChecked: '',
      blocked: false,
      blockedPhone: '',
      phoneCheckSequence: 0,
      location: null,
      map: null,
      marker: null,
      idempotencyKey: '',
      idempotencyFingerprint: '',
      reverseSequence: 0,
      successSnapshot: null,
      phoneChangeToken: '',
      phoneChanging: false,
      phoneChangeComplete: false,
      watixStatus: '',
      watixStatusChecking: false
    };

    this.locale = String(this.dataset.locale || window.Shopify?.locale || document.documentElement.lang || 'ar').toLowerCase();
    const shopifyLocale = String(window.Shopify?.locale || '').toLowerCase();
    const documentLocale = String(document.documentElement.lang || '').toLowerCase();
    this.lang = /^\/en(?:\/|$)/i.test(window.location.pathname) ||
      this.locale.startsWith('en') || shopifyLocale.startsWith('en') || documentLocale.startsWith('en')
      ? 'en'
      : 'ar';
    this.apiBase = String(this.dataset.apiBase || '').replace(/\/+$/, '');
    this.rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || this.dataset.rootUrl || '/';
    this.thresholdMinor = Number(this.dataset.shippingThresholdMinor) || 2500;
    this.shippingCostMinor = Number(this.dataset.shippingCostMinor) || 200;
    this.customerEmail = String(this.dataset.customerEmail || '').trim().toLowerCase();
    this.copy = this.readTranslations();
    this.cacheElements();
    if (this.els.safariLocationActions) {
      this.els.safariLocationActions.hidden = !isSafariBrowser();
    }
    this.prefillCustomerProfile();
    this.applyTranslations();
    this.populateWilayas();
    this.initializeClockLoaders();
    this.bindEvents();
    // T4S replaces the drawer DOM; refresh newly inserted COD triggers.
    this.cartObserver = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node =>
        node.nodeType === 1 && (node.matches?.('[data-bt-cod-open]') || node.querySelector?.('[data-bt-cod-open]'))
      ))) this.syncTriggers();
    });
    this.cartObserver.observe(document.body, { childList: true, subtree: true });
    document.documentElement.classList.add('bt-cod-mounted');
    const restoredEligibility = this.restoreEligibilityCache();
    this.setEligible(restoredEligibility);
    if (!restoredEligibility) this.bootstrapEligibility({ preserveCurrent: false });
  }

  disconnectedCallback() {
    this.cartObserver?.disconnect();
    if (this.abortController) this.abortController.abort();
    this.requestControllers.forEach((controller) => controller.abort());
    this.requestControllers.clear();
    window.clearTimeout(this.phoneTimer);
    window.clearTimeout(this.cartRefreshTimer);
    this.clearSuccessCountdown();
    this.destroyClockLoaders();
    this.releasePageLock();
  }

  readTranslations() {
    const node = this.querySelector('[data-bt-cod-i18n]');
    const all = node ? safeJson(node.textContent) : null;
    return (all && (all[this.lang] || all.en)) || {};
  }

  t(key, replacements = {}) {
    let value = String(this.copy[key] || key);
    Object.entries(replacements).forEach(([name, replacement]) => {
      value = value.split(`__${String(name).toUpperCase()}__`).join(String(replacement));
    });
    return value;
  }

  prefillCustomerProfile() {
    const name = String(this.dataset.customerName || '').trim();
    const phone = normalizeOmanPhone(this.dataset.customerPhone || '');
    const address = String(this.dataset.customerAddress || '').trim();

    if (name && !this.els.name.value.trim()) this.els.name.value = name;
    if (phone && !normalizeOmanPhone(this.els.phone.value)) this.els.phone.value = phone;
    if (address && !this.els.address.value.trim()) this.els.address.value = address;
  }

  cacheElements() {
    const $ = (selector) => this.querySelector(selector);
    const $$ = (selector) => Array.from(this.querySelectorAll(selector));
    this.els = {
      overlay: $('[data-bt-cod-overlay]'), dialog: $('[data-bt-cod-dialog]'),
      title: $('[data-bt-cod-title]'),
      main: $('[data-bt-cod-main]'), loading: $('[data-bt-cart-loading]'),
      loadingText: $('[data-bt-cart-loading] [data-bt-text="cartLoading"]'),
      content: $('[data-bt-cart-content]'), lines: $('[data-bt-lines]'),
      subtotal: $('[data-bt-subtotal]'), discount: $('[data-bt-discount]'),
      discountRow: $('[data-bt-discount-row]'), shipping: $('[data-bt-shipping]'),
      total: $('[data-bt-total]'), form: $('[data-bt-form]'),
      name: $('[data-bt-name]'), wilaya: $('[data-bt-wilaya]'),
      wilayaList: $('[data-bt-wilaya-list]'), wilayaKey: $('[data-bt-wilaya-key]'),
      address: $('[data-bt-address]'), phone: $('[data-bt-phone]'),
      coupon: $('[data-bt-coupon]'), couponApply: $('[data-bt-coupon-apply]'),
      couponSpinner: $('[data-bt-coupon-spinner]'),
      appliedCoupon: $('[data-bt-applied-coupon]'),
      appliedCouponCode: $('[data-bt-applied-coupon-code]'),
      couponRemove: $('[data-bt-coupon-remove]'),
      alert: $('[data-bt-alert]'), submit: $('[data-bt-submit]'),
      submitLabel: $('[data-bt-submit-label]'), submitSpinner: $('[data-bt-submit-spinner]'),
      blockedActions: $('[data-bt-blocked-actions]'),
      onlineCheckout: $('[data-bt-online-checkout]'),
      mapPanel: $('[data-bt-map-panel]'), mapCanvas: $('[data-bt-map]'),
      mapStatus: $('[data-bt-map-status]'), mapCurrent: $('[data-bt-map-current]'),
      safariLocationActions: $('[data-bt-safari-location-actions]'),
      locationHelpToggle: $('[data-bt-location-help-toggle]'),
      locationHelp: $('[data-bt-location-help]'),
      latitude: $('[data-bt-latitude]'),
      longitude: $('[data-bt-longitude]'), success: $('[data-bt-success]'),
      successMessage: $('[data-bt-success-message]'), successLink: $('[data-bt-success-link]'),
      successName: $('[data-bt-success-name]'), successOrder: $('[data-bt-success-order]'),
      successAddress: $('[data-bt-success-address]'), successPhone: $('[data-bt-success-phone]'),
      successTotal: $('[data-bt-success-total]'),
      confirmation: $('[data-bt-confirmation]'),
      confirmationMessage: $('[data-bt-confirmation-message]'),
      confirmationProgress: $('[data-bt-confirmation-progress]'),
      confirmationProgressBar: $('[data-bt-confirmation-progress-bar]'),
      countdown: $('[data-bt-countdown]'), countdownSeconds: $('[data-bt-countdown-seconds]'),
      manualConfirmation: $('[data-bt-manual-confirmation]'),
      manualWhatsApp: $('[data-bt-manual-whatsapp]'),
      manualWhatsAppLabel: $('[data-bt-manual-whatsapp] [data-bt-text="manualConfirm"]'),
      watixStatus: $('[data-bt-watix-status]'),
      changePhoneToggles: $$('[data-bt-change-phone-toggle]'),
      changePhoneForm: $('[data-bt-change-phone-form]'),
      changePhoneField: $('[data-bt-change-phone-field]'),
      changeAddressField: $('[data-bt-change-address-field]'),
      changePhone: $('[data-bt-change-phone]'),
      changeWilaya: $('[data-bt-change-wilaya]'),
      changeWilayaKey: $('[data-bt-change-wilaya-key]'),
      changeAddress: $('[data-bt-change-address]'),
      changePhoneAlert: $('[data-bt-phone-change-alert]'),
      changePhoneSave: $('[data-bt-change-phone-save]'),
      changePhoneSaveLabel: $('[data-bt-change-phone-save-label]'),
      changePhoneSpinner: $('[data-bt-change-phone-spinner]'),
      changePhoneCancel: $('[data-bt-change-phone-cancel]'),
      changePhoneCancelLabel: $('[data-bt-change-phone-cancel-label]')
    };
  }

  applyTranslations() {
    this.querySelectorAll('[data-bt-text]').forEach((element) => {
      const key = element.getAttribute('data-bt-text');
      element.textContent = this.t(key);
    });
    this.querySelectorAll('[data-bt-aria-label]').forEach((element) => {
      element.setAttribute('aria-label', this.t(element.getAttribute('data-bt-aria-label')));
    });
    this.querySelectorAll('[data-bt-placeholder]').forEach((element) => {
      const key = element.getAttribute('data-bt-placeholder');
      const value = this.t(key);
      if (value && value !== key) element.placeholder = value;
    });
    if (!this.els.name.hasAttribute('data-bt-placeholder')) this.els.name.placeholder = this.t('name');
    if (!this.els.address.hasAttribute('data-bt-placeholder')) this.els.address.placeholder = this.t('address');
    if (!this.els.phone.hasAttribute('data-bt-placeholder')) {
      this.els.phone.placeholder = this.t('phonePlaceholder') === 'phonePlaceholder'
        ? '7XXXXXXX / 9XXXXXXX'
        : this.t('phonePlaceholder');
    }
    this.els.coupon.placeholder = this.t('coupon');
  }

  populateWilayas() {
    const lists = Array.from(this.querySelectorAll('[data-bt-wilaya-list]'));
    if (lists.length) {
      lists.forEach((list) => {
        list.replaceChildren();
        OMAN_WILAYAS.forEach((governorate) => {
          governorate.items.forEach(([code, ar, en]) => {
            const option = document.createElement('option');
            option.value = this.lang === 'ar' ? ar : en;
            option.label = `${this.lang === 'ar' ? en : ar} · ${code}`;
            option.dataset.code = code;
            option.dataset.ar = ar;
            option.dataset.en = en;
            list.appendChild(option);
          });
        });
      });
      return;
    }

    // Keep old theme copies functional while the search input markup propagates.
    if (!this.els.wilaya || this.els.wilaya.tagName !== 'SELECT') return;
    OMAN_WILAYAS.forEach((governorate) => {
      const group = document.createElement('optgroup');
      group.label = governorate[this.lang];
      governorate.items.forEach(([code, ar, en]) => {
        const option = document.createElement('option');
        option.value = code;
        option.textContent = this.lang === 'ar' ? ar : en;
        option.dataset.ar = ar;
        option.dataset.en = en;
        group.appendChild(option);
      });
      this.els.wilaya.appendChild(group);
    });
  }

  initializeClockLoaders() {
    const loaders = Array.from(this.querySelectorAll('[data-bt-clock-loader]'));
    loaders.forEach((element) => {
      let role = String(element.getAttribute('data-bt-clock-loader') || '').trim().toLowerCase();
      if (!role) {
        if (element === this.els.couponSpinner || element.matches('[data-bt-coupon-spinner]')) role = 'coupon';
        else if (element === this.els.submitSpinner || element.matches('[data-bt-submit-spinner]')) role = 'submit';
        else if (element === this.els.changePhoneSpinner || element.matches('[data-bt-change-phone-spinner]')) role = 'contact';
        else if (element.closest('[data-bt-cart-loading]')) role = 'cart';
      }
      if (role === 'phone') role = 'contact';
      if (!role) return;
      if (!this.clockLoaders.has(role)) this.clockLoaders.set(role, new Set());
      this.clockLoaders.get(role).add(element);
      element.hidden = true;
      element.dataset.btClockActive = 'false';
      if (this.prefersReducedMotion) element.dataset.btReducedMotion = 'true';
    });
  }

  ensureLottie() {
    if (window.lottie && typeof window.lottie.loadAnimation === 'function') {
      return Promise.resolve(window.lottie);
    }
    if (this.lottiePromise) return this.lottiePromise;
    const source = String(this.dataset.lottieUrl || '').trim();
    if (!source) return Promise.reject(new Error('LOTTIE_URL_MISSING'));

    this.lottiePromise = new Promise((resolve, reject) => {
      const existing = Array.from(document.scripts).find((script) => (
        script.hasAttribute('data-bt-lottie-runtime') ||
        script.hasAttribute('data-bt-cod-lottie-runtime') ||
        script.src === new URL(source, document.baseURI).href
      ));
      const script = existing || document.createElement('script');
      let settled = false;
      const finish = (error) => {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        script.removeEventListener('load', onLoad);
        script.removeEventListener('error', onError);
        if (!error && window.lottie && typeof window.lottie.loadAnimation === 'function') {
          resolve(window.lottie);
        } else {
          reject(error || new Error('LOTTIE_UNAVAILABLE'));
        }
      };
      const onLoad = () => finish();
      const onError = () => finish(new Error('LOTTIE_LOAD_FAILED'));
      const timer = window.setTimeout(() => finish(new Error('LOTTIE_LOAD_TIMEOUT')), 8000);
      script.addEventListener('load', onLoad, { once: true });
      script.addEventListener('error', onError, { once: true });
      if (!existing) {
        script.src = source;
        script.defer = true;
        script.dataset.btCodLottieRuntime = '';
        document.head.appendChild(script);
      }
    }).catch((error) => {
      this.lottiePromise = null;
      throw error;
    });
    return this.lottiePromise;
  }

  async mountClockLoader(element) {
    const clockUrl = String(this.dataset.clockUrl || '').trim();
    if (
      !clockUrl || !element || this.prefersReducedMotion ||
      element.dataset.btClockMounting === 'true'
    ) return;
    element.dataset.btClockMounting = 'true';
    try {
      const lottie = await this.ensureLottie();
      if (!element.isConnected || this.clockAnimations.has(element)) return;
      const animation = lottie.loadAnimation({
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: clockUrl,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          progressiveLoad: true
        }
      });
      this.clockAnimations.set(element, animation);
      const markReady = () => {
        if (!element.isConnected) return;
        element.dataset.btLottieReady = 'true';
        if (element.dataset.btClockActive === 'true') animation.play();
        else animation.pause();
      };
      if (typeof animation.addEventListener === 'function') {
        animation.addEventListener('DOMLoaded', markReady);
      } else {
        markReady();
      }
    } catch (_) {
      if (element?.isConnected) element.dataset.btLottieReady = 'false';
    } finally {
      if (element) delete element.dataset.btClockMounting;
    }
  }

  setClockLoading(role, active) {
    const normalizedRole = role === 'phone' ? 'contact' : role;
    const loaders = this.clockLoaders?.get(normalizedRole);
    if (!loaders) return;
    loaders.forEach((element) => {
      const shouldShow = Boolean(active);
      element.dataset.btClockActive = String(Boolean(active));
      element.hidden = !shouldShow;
      if (shouldShow) element.style.removeProperty('display');
      else element.style.setProperty('display', 'none', 'important');
      if (shouldShow && !element.querySelector('.hb-loading-logo')) {
        const logo = document.createElement('img');
        logo.className = 'hb-loading-logo';
        logo.src = 'https://cdn.shopify.com/s/files/1/0721/8551/2126/files/hl.png';
        logo.alt = '';
        element.replaceChildren(logo);
      }
      const animation = this.clockAnimations.get(element);
      if (!animation) return;
      try {
        if (shouldShow) animation.play();
        else animation.pause();
      } catch (_) { /* The fallback remains available if Lottie stops unexpectedly. */ }
    });
  }

  stopClockLoaders() {
    if (!this.clockLoaders) return;
    this.clockLoaders.forEach((_loaders, role) => this.setClockLoading(role, false));
  }

  destroyClockLoaders() {
    this.stopClockLoaders();
    this.clockAnimations?.forEach((animation) => {
      try { animation.destroy(); } catch (_) { /* Nothing else to release. */ }
    });
    this.clockAnimations?.clear();
  }

  bindEvents() {
    const signal = this.abortController.signal;
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-bt-cod-open]');
      if (!trigger) return;
      event.preventDefault();
      if (this.state.open || this.state.opening) return;
      void this.open(trigger);
    }, { signal });

    this.els.overlay.addEventListener('click', (event) => {
      if (event.target === this.els.overlay) this.close();
    }, { signal });
    this.querySelectorAll('[data-bt-cod-close]').forEach((button) => {
      button.addEventListener('click', () => this.close(), { signal });
    });
    this.querySelector('[data-bt-location-open]').addEventListener('click', () => this.openMap(), { signal });
    this.els.mapCurrent?.addEventListener('click', () => this.locateFromBrowser(), { signal });
    this.els.locationHelpToggle?.addEventListener('click', () => {
      const shouldOpen = this.els.locationHelp.hidden;
      this.els.locationHelp.hidden = !shouldOpen;
      this.els.locationHelpToggle.setAttribute('aria-expanded', String(shouldOpen));
    }, { signal });
    this.querySelector('[data-bt-map-close]').addEventListener('click', () => {
      this.els.mapPanel.hidden = true;
      if (this.els.locationHelp) this.els.locationHelp.hidden = true;
      this.els.locationHelpToggle?.setAttribute('aria-expanded', 'false');
    }, { signal });
    this.els.couponApply.addEventListener('click', () => this.applyCoupon(), { signal });
    this.els.couponRemove?.addEventListener('click', () => this.removeCoupon(), { signal });
    this.els.form.addEventListener('submit', (event) => this.submitOrder(event), { signal });
    this.els.changePhoneToggles.forEach((button) => {
      button.addEventListener('click', () => {
        const mode = button.dataset.btEditMode === 'address' ? 'address' : 'phone';
        this.togglePhoneChange(this.els.changePhoneForm.hidden, mode);
      }, { signal });
    });
    this.els.changePhoneCancel.addEventListener('click', () => this.togglePhoneChange(false), { signal });
    this.els.changePhoneForm.addEventListener('submit', (event) => this.submitPhoneChange(event), { signal });
    this.els.lines.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bt-line-remove]');
      if (button) this.removeLine(button);
    }, { signal });
    this.els.phone.addEventListener('input', () => this.onPhoneInput(), { signal });
    this.els.wilaya.addEventListener('input', () => {
      this.syncWilayaKey(this.els.wilaya, this.els.wilayaKey);
      if (this.els.wilaya.type === 'hidden') this.state.quoteToken = '';
      else this.invalidateQuote();
      this.clearDeliveryValidity(this.els.wilaya, this.els.address);
    }, { signal });
    this.els.wilaya.addEventListener('change', () => {
      this.syncWilayaKey(this.els.wilaya, this.els.wilayaKey);
      if (this.els.wilaya.type === 'hidden') this.state.quoteToken = '';
      else this.invalidateQuote();
      this.clearDeliveryValidity(this.els.wilaya, this.els.address);
    }, { signal });
    this.els.address.addEventListener('input', () => {
      this.els.address.setCustomValidity('');
      if (!this.settingAddressFromMap) {
        this.setWilayaField(this.els.wilaya, this.els.wilayaKey, null);
        this.state.location = null;
        this.state.quoteToken = '';
      }
    }, { signal });
    this.els.changeWilaya?.addEventListener('input', () => {
      this.syncWilayaKey(this.els.changeWilaya, this.els.changeWilayaKey);
      this.clearDeliveryValidity(this.els.changeWilaya, this.els.changeAddress);
    }, { signal });
    this.els.changeWilaya?.addEventListener('change', () => {
      this.syncWilayaKey(this.els.changeWilaya, this.els.changeWilayaKey);
      this.clearDeliveryValidity(this.els.changeWilaya, this.els.changeAddress);
    }, { signal });
    this.els.changeAddress?.addEventListener('input', () => {
      this.els.changeAddress.setCustomValidity('');
      this.setWilayaField(this.els.changeWilaya, this.els.changeWilayaKey, null);
    }, { signal });
    this.els.coupon.addEventListener('input', () => {
      if (couponComparisonKey(this.state.appliedCoupon) !== couponComparisonKey(this.normalizedCoupon())) {
        this.invalidateQuote();
      }
    }, { signal });
    this.els.coupon.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      this.applyCoupon();
    }, { signal });
    this.els.dialog.addEventListener('keydown', (event) => this.onDialogKeydown(event), { signal });

    ['cart:update', 'cart:main:render', 'cart:drawer:render', 'cart:reload'].forEach((eventName) => {
      document.addEventListener(eventName, () => this.onExternalCartChange(), { signal });
    });
    document.addEventListener('shopify:section:load', () => this.syncTriggers(), { signal });
    window.addEventListener('pageshow', () => this.bootstrapEligibility({ preserveCurrent: false }), { signal });
  }

  invalidateQuote() {
    this.state.quote = null;
    this.state.quoteToken = '';
    this.state.appliedCoupon = '';
    this.renderSummary();
  }

  syncWilayaKey(input, keyInput) {
    if (!input) return null;
    const record = findWilaya(input.value);
    if (keyInput) keyInput.value = record?.code || '';
    return record;
  }

  clearDeliveryValidity(wilayaInput, addressInput) {
    wilayaInput?.setCustomValidity('');
    addressInput?.setCustomValidity('');
  }

  translatedOr(key, fallbackKey) {
    const value = this.t(key);
    return value === key ? this.t(fallbackKey) : value;
  }

  validateDeliveryFields(wilayaInput, keyInput, addressInput, { report = false } = {}) {
    const address = stripOmanCountry(
      addressInput?.value,
      this.lang === 'ar' ? '، ' : ', '
    );
    if (addressInput && addressInput.value !== address) addressInput.value = address;
    const wilaya = this.selectedWilaya(wilayaInput, keyInput, addressInput);
    const validWilaya = Boolean(wilaya.matched && wilaya.code);
    const addressRequired = true;
    const validAddress = address.length >= 2;

    wilayaInput?.setCustomValidity('');
    addressInput?.setCustomValidity(validAddress && validWilaya
      ? ''
      : this.t('requiredFields'));

    if (report && (!validAddress || !validWilaya)) addressInput?.reportValidity();
    return { valid: validWilaya && validAddress, wilaya, address, addressRequired };
  }

  eligibilityCacheBinding() {
    return {
      origin: window.location.origin,
      shop: String(this.dataset.shopDomain || '').trim().toLowerCase()
    };
  }

  restoreEligibilityCache() {
    try {
      const cached = safeJson(window.sessionStorage.getItem('bt.cod.eligibility.v1'));
      const binding = this.eligibilityCacheBinding();
      const expiresAt = Number(cached?.expiresAt || 0);
      const token = String(cached?.eligibilityToken || '');
      if (
        cached?.origin !== binding.origin ||
        cached?.shop !== binding.shop ||
        String(cached?.country || '').toUpperCase() !== 'OM' ||
        !token ||
        expiresAt <= Date.now() + 30000
      ) {
        window.sessionStorage.removeItem('bt.cod.eligibility.v1');
        return false;
      }
      this.state.eligibilityToken = token;
      this.state.eligibilityExpiresAt = expiresAt;
      this.state.eligibilityCountry = 'OM';
      return true;
    } catch (_) {
      return false;
    }
  }

  persistEligibilityCache() {
    try {
      const token = String(this.state.eligibilityToken || '');
      const expiresAt = Number(this.state.eligibilityExpiresAt || 0);
      if (!token || expiresAt <= Date.now() + 30000 || this.state.eligibilityCountry !== 'OM') {
        window.sessionStorage.removeItem('bt.cod.eligibility.v1');
        return;
      }
      const binding = this.eligibilityCacheBinding();
      window.sessionStorage.setItem('bt.cod.eligibility.v1', JSON.stringify({
        origin: binding.origin,
        shop: binding.shop,
        eligibilityToken: token,
        expiresAt,
        country: 'OM'
      }));
    } catch (_) { /* sessionStorage may be disabled; eligibility still works for this page. */ }
  }

  clearEligibilityCache() {
    try { window.sessionStorage.removeItem('bt.cod.eligibility.v1'); } catch (_) { /* Ignore storage denial. */ }
  }

  acceptEligibility(result) {
    if (!result || result.eligible !== true) return false;
    this.state.eligibilityToken = String(result.eligibilityToken || '');
    this.state.eligibilityExpiresAt = Number(result.expiresIn) > 0
      ? Date.now() + (Number(result.expiresIn) * 1000)
      : 0;
    this.state.eligibilityCountry = String(result.country || 'OM').toUpperCase() || 'OM';
    document.documentElement.classList.remove('bt-cod-country-denied');
    this.setEligible(true);
    this.persistEligibilityCache();
    return true;
  }

  async bootstrapEligibility({ preserveCurrent = this.state.eligible } = {}) {
    if (this.eligibilityPromise) return this.eligibilityPromise;
    if (!preserveCurrent) this.setEligible(false);
    this.eligibilityPromise = (async () => {
      const shop = this.dataset.shopDomain || '';
      const directTask = this.api('eligibility', { shop }, 4500).catch(() => null);
      const countryTask = this.detectIpCountry()
        .catch(() => this.detectShopifyCountry())
        .then((country) => String(country || '').toUpperCase())
        .catch(() => '');
      const [direct, country] = await Promise.all([directTask, countryTask]);
      const directCountry = String(direct?.country || '').toUpperCase();

      // The browser IP check is the fast visible gate used by the currency
      // script. The server remains the second authoritative gate.
      if (country !== 'OM' || (directCountry && directCountry !== 'OM')) {
        this.state.eligibilityToken = '';
        this.state.eligibilityExpiresAt = 0;
        this.state.eligibilityCountry = '';
        this.clearEligibilityCache();
        this.setEligible(false);
        document.documentElement.classList.add('bt-cod-country-denied');
        return false;
      }

      let verified = direct;
      if (verified?.eligible !== true) {
        verified = await this.api('eligibility', { shopifyCountry: country, shop }, 4500).catch(() => null);
      }
      if (verified?.eligible === true) return this.acceptEligibility(verified);

      this.state.eligibilityToken = '';
      this.state.eligibilityExpiresAt = 0;
      this.state.eligibilityCountry = '';
      this.clearEligibilityCache();
      this.setEligible(false);
      document.documentElement.classList.add('bt-cod-country-denied');
      return false;
    })();
    try {
      return await this.eligibilityPromise;
    } finally {
      this.eligibilityPromise = null;
    }
  }

  async ensureEligibilityFresh({ force = false } = {}) {
    const expiresSoon = this.state.eligibilityExpiresAt > 0
      && this.state.eligibilityExpiresAt - Date.now() < 30000;
    if (!force && this.state.eligible && !expiresSoon) return true;
    this.state.eligibilityToken = '';
    this.state.eligibilityExpiresAt = 0;
    this.state.eligibilityCountry = '';
    this.clearEligibilityCache();
    this.setEligible(false);
    return this.bootstrapEligibility({ preserveCurrent: false });
  }

  async detectShopifyCountry() {
    const url = `${this.rootUrl}browsing_context_suggestions.json`.replace(/([^:]\/)\/+/g, '$1');
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(url, {
        method: 'GET', credentials: 'same-origin', cache: 'no-store',
        headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) throw new Error('COUNTRY_LOOKUP_FAILED');
      const data = await response.json();
      return String(data?.detected_values?.country?.handle || '').toUpperCase();
    } finally {
      window.clearTimeout(timer);
    }
  }

  async detectIpCountry() {
    try {
      const sharedGeo = safeJson(window.sessionStorage.getItem('bt.geo.current.v1'));
      const sharedCountry = String(sharedGeo?.country || '').toUpperCase();
      const sharedAt = Number(sharedGeo?.detectedAt || 0);
      if (sharedCountry && Date.now() - sharedAt < 2 * 60 * 1000) return sharedCountry;
    } catch (_) { /* Continue with a fresh lookup when storage is unavailable. */ }

    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch('https://ipinfo.io/json', {
        method: 'GET', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal
      });
      if (!response.ok) throw new Error('IP_COUNTRY_LOOKUP_FAILED');
      const data = await response.json();
      return String(data?.country || '').toUpperCase();
    } finally {
      window.clearTimeout(timer);
    }
  }

  setEligible(eligible) {
    this.state.eligible = Boolean(eligible);
    document.documentElement.classList.toggle('bt-cod-ready', this.state.eligible);
    this.syncTriggers();
  }

  syncTriggers() {
    const codVisible = this.state.eligible && !this.state.blocked;
    document.querySelectorAll('[data-bt-cod-open]').forEach((trigger) => {
      trigger.hidden = !codVisible;
      // Some cart-drawer button styles force display:flex and override the
      // browser's native [hidden] rule. Enforce the visibility state inline.
      if (codVisible) trigger.style.removeProperty('display');
      else trigger.style.setProperty('display', 'none', 'important');
      trigger.setAttribute('aria-hidden', String(!codVisible));
      const actions = trigger.closest('[data-bt-cart-checkout-actions]');
      if (actions) actions.classList.toggle('bt-cod-actions-ready', codVisible);
    });
  }

  async closeCartDrawer() {
    const drawer = document.getElementById('t4s-mini_cart');
    if (drawer?.getAttribute('aria-hidden') === 'false') {
      window.T4SThemeSP?.Drawer?.close();
      await new Promise(resolve => window.setTimeout(resolve, 350));
    }
  }

  releasePageLock() {
    document.body.classList.remove('bt-cod-scroll-locked');
    window.requestAnimationFrame(() => {
      if (this.state.open) return;
      const lockedDialog = document.querySelector('dialog[open][scroll-lock]');
      if (!lockedDialog) document.documentElement.removeAttribute('scroll-lock');
    });
  }

  async open(trigger) {
    if (!this.state.eligible || this.state.submitting || this.state.open || this.state.opening) return;
    this.state.opening = true;
    try {
      if (!(await this.ensureEligibilityFresh())) return;
      await this.closeCartDrawer();
    } catch (_) {
      this.releasePageLock();
      return;
    } finally {
      this.state.opening = false;
    }
    this.opener = trigger && !trigger.closest('#t4s-mini_cart') ? trigger : null;
    this.clearSuccessCountdown();
    this.state.open = true;
    this.state.completed = false;
    this.state.blocked = false;
    this.state.blockedPhone = '';
    this.state.successSnapshot = null;
    this.state.phoneChangeToken = '';
    this.state.phoneChanging = false;
    this.state.phoneChangeComplete = false;
    this.els.title.textContent = this.t('title');
    this.els.success.hidden = true;
    this.els.manualConfirmation.hidden = true;
    this.els.changePhoneForm.hidden = true;
    this.els.changePhoneToggles.forEach((button) => {
      button.hidden = false;
      button.setAttribute('aria-expanded', 'false');
    });
    this.els.changePhone.disabled = false;
    this.els.changePhoneSave.hidden = false;
    this.els.changePhoneCancelLabel.textContent = this.t('cancel');
    this.els.submit.hidden = false;
    this.els.blockedActions.hidden = true;
    this.clearPhoneChangeAlert();
    this.els.content.hidden = true;
    this.els.loading.hidden = false;
    this.setClockLoading('cart', true);
    this.els.loadingText.textContent = this.t('cartLoading');
    this.clearAlert();
    this.els.overlay.hidden = false;
    this.els.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bt-cod-scroll-locked');
    window.requestAnimationFrame(() => this.els.dialog.focus({ preventScroll: true }));

    try {
      await this.loadCart();
    } catch (_) {
      this.els.loadingText.textContent = this.t('networkError');
    } finally {
      this.setClockLoading('cart', false);
    }
  }

  close() {
    if (!this.state.open || this.state.submitting) return;
    this.clearSuccessCountdown();
    window.clearTimeout(this.phoneTimer);
    this.state.phoneCheckSequence += 1;
    this.stopClockLoaders();
    this.state.open = false;
    this.els.overlay.hidden = true;
    this.els.overlay.setAttribute('aria-hidden', 'true');
    this.releasePageLock();
    if (this.opener && this.opener.isConnected && this.opener.getClientRects().length > 0) {
      this.opener.focus({ preventScroll: true });
    }
    this.opener = null;
  }

  onDialogKeydown(event) {
    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(this.els.dialog.querySelectorAll(
      'button:not([disabled]):not([hidden]), a[href]:not([hidden]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => element.getClientRects().length > 0);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }

  cartUrl(path) {
    const root = this.rootUrl.endsWith('/') ? this.rootUrl : `${this.rootUrl}/`;
    return `${root}${path}`;
  }

  async fetchCart() {
    const response = await fetch(this.cartUrl('cart.js'), {
      method: 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('CART_LOAD_FAILED');
    return response.json();
  }

  async loadCart() {
    const cart = await this.fetchCart();
    this.state.cart = cart;
    this.state.quote = null;
    this.state.quoteToken = '';
    this.state.appliedCoupon = '';
    this.renderCart();
    this.setClockLoading('cart', false);
    this.els.loading.hidden = true;
    this.els.content.hidden = false;
    if (Array.isArray(cart.items) && cart.items.length > 0) {
      await this.applyCoupon({ automatic: true, silent: true });
    }
    return cart;
  }

  renderCart() {
    const cart = this.state.cart;
    this.els.lines.replaceChildren();
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      this.els.form.hidden = true;
      if (this.state.open) this.close();
      return;
    }
    if (this.hasUnsupportedItems(cart)) {
      this.showAlert(this.t('unsupportedCart'));
      this.els.submit.disabled = true;
    } else if (!this.state.submitting && !this.state.blocked) {
      this.els.submit.disabled = false;
    }
    this.els.form.hidden = false;
    cart.items.forEach((item) => this.els.lines.appendChild(this.createLine(item)));
    this.renderSummary();
  }

  createLine(item) {
    const row = document.createElement('article');
    row.className = 'bt-cod-line';

    const productUrl = this.safeProductUrl(item?.url || '');
    const imageWrap = document.createElement(productUrl ? 'a' : 'div');
    imageWrap.className = 'bt-cod-line-image-wrap';
    if (productUrl) {
      imageWrap.href = productUrl;
      imageWrap.setAttribute('aria-label', String(item.product_title || item.title || ''));
    }
    const imageUrl = this.safeImageUrl(item?.featured_image?.url || item?.image || '');
    if (imageUrl) {
      const image = document.createElement('img');
      image.className = 'bt-cod-line-image';
      image.src = imageUrl;
      image.alt = '';
      image.loading = 'lazy';
      image.width = 80;
      image.height = 96;
      imageWrap.appendChild(image);
    }
    const quantity = document.createElement('span');
    quantity.className = 'bt-cod-line-quantity';
    quantity.textContent = String(item.quantity || 1);
    imageWrap.appendChild(quantity);

    const info = document.createElement('div');
    info.className = 'bt-cod-line-info';
    const title = document.createElement(productUrl ? 'a' : 'p');
    title.className = 'bt-cod-line-title';
    title.textContent = String(item.product_title || item.title || '');
    if (productUrl) title.href = productUrl;
    info.appendChild(title);
    const variantTitle = String(item.variant_title || '');
    if (variantTitle && variantTitle.toLowerCase() !== 'default title') {
      const variant = document.createElement('p');
      variant.className = 'bt-cod-line-variant';
      variant.textContent = variantTitle;
      info.appendChild(variant);
    }

    const price = document.createElement('div');
    price.className = 'bt-cod-line-price';
    const amount = document.createElement('span');
    amount.textContent = this.money(item.final_line_price ?? item.line_price ?? 0);
    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'bt-cod-line-remove';
    remove.setAttribute('data-bt-line-remove', '');
    remove.dataset.lineKey = String(item.key || '');
    remove.setAttribute('aria-label', `${this.t('remove')}: ${title.textContent}`);
    remove.textContent = '×';
    price.append(amount, remove);

    row.append(imageWrap, info, price);
    return row;
  }

  safeImageUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  safeProductUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin && ['http:', 'https:'].includes(url.protocol)
        ? url.href
        : '';
    } catch (_) { return ''; }
  }

  calculatePreview() {
    const cart = this.state.cart || {};
    const items = Array.isArray(cart.items) ? cart.items : [];
    const shippableSubtotal = items.reduce((sum, item) => {
      return sum + (item.requires_shipping === false ? 0 : Number(item.final_line_price ?? item.line_price ?? 0));
    }, 0);
    const hasShippableItems = items.some((item) => item.requires_shipping !== false);
    const subtotal = Number(cart.total_price ?? shippableSubtotal) || 0;
    const shipping = !hasShippableItems || shippableSubtotal >= this.thresholdMinor ? 0 : this.shippingCostMinor;
    return { subtotal, discount: 0, shipping, total: subtotal + shipping };
  }

  hasUnsupportedItems(cart = this.state.cart) {
    return (cart?.items || []).some((item) => {
      const properties = Object.values(item.properties || {}).filter((value) => value !== null && value !== '');
      return Boolean(item.selling_plan_allocation) || properties.length > 0;
    });
  }

  renderSummary() {
    const amounts = this.state.quote || this.calculatePreview();
    const exact = amounts.exact || null;
    const displayMoney = (key) => exact?.[key] ? `OMR ${exact[key]}` : this.money(amounts[key]);
    const hasDiscount = exact ? exact.discount !== '0.000' : amounts.discount > 0;
    const freeShipping = exact ? exact.shipping === '0.000' : amounts.shipping === 0;
    this.els.subtotal.textContent = displayMoney('subtotal');
    this.els.discountRow.hidden = !hasDiscount;
    this.els.discount.textContent = `- ${displayMoney('discount')}`;
    this.els.shipping.textContent = freeShipping ? this.t('free') : displayMoney('shipping');
    this.els.total.textContent = displayMoney('total');
    // Keep the processing label stable while the final quote/order request is running.
    // A late quote response must not restore the price while the loader is still active.
    if (!this.state.submitting) {
      this.els.submitLabel.textContent = this.t('buyNow', { total: displayMoney('total') });
    }
    if (this.els.appliedCoupon && this.els.appliedCouponCode) {
      const code = String(this.state.appliedCoupon || '').trim();
      this.els.appliedCoupon.hidden = !code;
      this.els.appliedCouponCode.textContent = code;
    }
  }

  async removeCoupon() {
    if (this.state.submitting || this.els.couponApply.disabled) return;
    this.els.coupon.value = '';
    this.state.appliedCoupon = '';
    this.state.quote = null;
    this.state.quoteToken = '';
    this.renderSummary();
    this.clearAlert();
    await this.applyCoupon({ automatic: true, silent: true });
  }

  money(minorValue) {
    const amount = (Number(minorValue) || 0) / 100;
    return `OMR ${amount.toFixed(3)}`;
  }

  moneyValue(minorValue) {
    return ((Number(minorValue) || 0) / 100).toFixed(3);
  }

  cartSignature(cart = this.state.cart) {
    return (cart?.items || []).map((item) => `${item.key}:${item.quantity}`).sort().join('|');
  }

  async removeLine(button) {
    if (!button.dataset.lineKey || button.disabled || this.state.submitting) return;
    button.disabled = true;
    try {
      const payload = { id: button.dataset.lineKey, quantity: 0 };
      const response = await fetch(this.cartUrl('cart/change.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await response.json();
      if (!response.ok || data.errors) throw new Error('CART_CHANGE_FAILED');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      this.state.cart = data;
      this.state.quote = null;
      this.state.quoteToken = '';
      this.state.appliedCoupon = '';
      this.renderCart();
      if (Array.isArray(data.items) && data.items.length > 0) {
        await this.applyCoupon({ automatic: true, silent: true });
      }
    } catch (_) {
      this.showAlert(this.t('networkError'));
      button.disabled = false;
    }
  }

  onExternalCartChange() {
    this.syncTriggers();
    if (!this.state.open || this.state.submitting || this.state.completed) return;
    window.clearTimeout(this.cartRefreshTimer);
    this.cartRefreshTimer = window.setTimeout(async () => {
      try {
        const cart = await this.fetchCart();
        if (this.cartSignature(cart) !== this.cartSignature()) {
          this.state.cart = cart;
          this.state.quote = null;
          this.state.quoteToken = '';
          this.state.appliedCoupon = '';
          this.renderCart();
          if (!this.state.open) return;
          if (Array.isArray(cart.items) && cart.items.length > 0) {
            await this.applyCoupon({ automatic: true, silent: true });
          }
          this.showAlert(this.t('cartChanged'));
        }
      } catch (_) { /* Keep the current modal; submission rechecks the cart. */ }
    }, 180);
  }

  normalizedCoupon() {
    return String(this.els.coupon.value || '').trim();
  }

  async applyCoupon({ forOrder = false, automatic = false, silent = false } = {}) {
    const code = this.normalizedCoupon();
    if (!code && !forOrder && !automatic) {
      this.state.quote = null;
      this.state.quoteToken = '';
      this.state.appliedCoupon = '';
      this.renderSummary();
      this.clearAlert();
      return true;
    }
    if (!this.state.cart || (!forOrder && this.els.couponApply.disabled)) return false;
    this.els.couponApply.disabled = true;
    if (!forOrder) this.setClockLoading('coupon', true);
    this.clearAlert();
    const quotePhone = normalizeOmanPhone(this.els.phone.value);
    try {
      if (!(await this.ensureEligibilityFresh())) throw new Error('ELIGIBILITY_EXPIRED');
      const wilaya = this.selectedWilaya();
      const result = await this.api('quote', {
        shop: this.dataset.shopDomain || '',
        eligibilityToken: this.state.eligibilityToken,
        language: this.lang,
        items: this.orderLines(),
        discountCode: code || undefined,
        wilaya: wilaya.matched ? wilaya.code : undefined,
        email: this.customerEmail || undefined,
        phone: quotePhone
          ? `+968${quotePhone}`
          : undefined
      });
      const quote = this.parseQuote(result?.quote || result);
      const quoteToken = String(result?.quoteToken || result?.quote?.token || '');
      const discountRejected = result?.discountCode?.accepted === false;
      const serverCoupon = String(
        result?.discountCodeApplied || result?.discountCode?.code || code
      ).trim();
      const discountMismatch = Boolean(
        code && serverCoupon && couponComparisonKey(code) !== couponComparisonKey(serverCoupon)
      );
      if (!quote || result?.valid === false || discountRejected || discountMismatch) {
        const errorCode = code ? 'INVALID_COUPON' : 'QUOTE_INVALID';
        throw Object.assign(new Error(errorCode), { code: errorCode });
      }
      if (forOrder && !quoteToken) {
        throw Object.assign(new Error('QUOTE_TOKEN_MISSING'), { code: 'QUOTE_TOKEN_MISSING' });
      }
      this.state.quote = quote;
      this.state.quoteToken = quoteToken;
      this.state.appliedCoupon = code ? (serverCoupon || code) : '';
      this.renderSummary();
      if (!forOrder && code && !silent) this.showAlert(this.t('couponApplied'), 'success');
      return true;
    } catch (error) {
      this.state.quote = null;
      this.state.quoteToken = '';
      this.state.appliedCoupon = '';
      this.renderSummary();
      if (
        (error.code === 'COD_BLACKLISTED' || error.payload?.code === 'COD_BLACKLISTED') &&
        quotePhone && normalizeOmanPhone(this.els.phone.value) === quotePhone
      ) {
        this.handleBlocked(error.payload?.checkoutUrl, quotePhone);
        return false;
      }
      const invalidCoupon = ['INVALID_COUPON', 'INVALID_DISCOUNT_CODE', 'DISCOUNT_CODE_NOT_APPLIED'].includes(error.code);
      if (!silent) this.showAlert(invalidCoupon ? this.t('couponInvalid') : this.t('quoteError'));
      return false;
    } finally {
      if (!forOrder) this.setClockLoading('coupon', false);
      this.els.couponApply.disabled = this.state.submitting;
    }
  }

  parseQuote(value) {
    const source = value?.amounts || value;
    const hasMinorAmounts = source?.subtotalMinor !== undefined;
    const toMinor = (amount) => Math.round(Number(amount) * 100);
    const subtotal = hasMinorAmounts ? Number(source?.subtotalMinor) : toMinor(source?.subtotal);
    const discount = hasMinorAmounts ? Number(source?.discountMinor || 0) : toMinor(source?.discount || 0);
    const shipping = hasMinorAmounts ? Number(source?.shippingMinor) : toMinor(source?.shipping);
    const total = hasMinorAmounts ? Number(source?.totalMinor) : toMinor(source?.total);
    if (![subtotal, discount, shipping, total].every(Number.isFinite)) return null;
    const exact = hasMinorAmounts ? null : {
      subtotal: normalizeMoneyDecimal(source?.subtotal),
      discount: normalizeMoneyDecimal(source?.discount || 0),
      shipping: normalizeMoneyDecimal(source?.shipping),
      total: normalizeMoneyDecimal(source?.total)
    };
    if (exact && Object.values(exact).some((amount) => !amount)) return null;
    return { subtotal, discount, shipping, total, exact };
  }

  onPhoneInput() {
    this.state.phoneChecked = '';
    this.state.quoteToken = '';
    window.clearTimeout(this.phoneTimer);
    const sequence = ++this.state.phoneCheckSequence;
    const phone = normalizeOmanPhone(this.els.phone.value);
    if (this.state.blocked) {
      if (!phone || phone === this.state.blockedPhone) return;
      this.clearBlockedPhone();
    }
    if (!phone) return;
    this.phoneTimer = window.setTimeout(() => {
      this.checkPhone({ silent: true, expectedPhone: phone, sequence });
    }, 550);
  }

  async checkPhone({ silent = false, expectedPhone = '', sequence = 0 } = {}) {
    window.clearTimeout(this.phoneTimer);
    const phone = expectedPhone || normalizeOmanPhone(this.els.phone.value);
    const requestSequence = sequence || ++this.state.phoneCheckSequence;
    if (!phone) {
      if (!silent) this.showAlert(this.t('invalidPhone'));
      return false;
    }
    if (this.state.blocked && this.state.blockedPhone === phone) return false;
    if (this.state.phoneChecked === phone && !this.state.blocked) return true;
    if (!silent) this.showAlert(this.t('checkingPhone'), 'success');
    try {
      if (!(await this.ensureEligibilityFresh())) throw new Error('ELIGIBILITY_EXPIRED');
      const result = await this.api('blacklist-check', {
        shop: this.dataset.shopDomain || '',
        eligibilityToken: this.state.eligibilityToken,
        phone: `+968${phone}`
      }, 7000);
      if (
        requestSequence !== this.state.phoneCheckSequence ||
        normalizeOmanPhone(this.els.phone.value) !== phone
      ) return false;
      if (result?.codAllowed === false || result?.code === 'COD_BLACKLISTED') {
        this.handleBlocked(result?.checkoutUrl, phone);
        return false;
      }
      if (this.state.blocked) this.clearBlockedPhone();
      this.state.phoneChecked = phone;
      if (!silent) this.clearAlert();
      return true;
    } catch (error) {
      if (
        requestSequence !== this.state.phoneCheckSequence ||
        normalizeOmanPhone(this.els.phone.value) !== phone
      ) return false;
      if (error.code === 'COD_BLACKLISTED' || error.payload?.codAllowed === false) {
        this.handleBlocked(error.payload?.checkoutUrl, phone);
        return false;
      }
      if (!silent) this.showAlert(this.t('networkError'));
      return false;
    }
  }

  handleBlocked(checkoutUrl, checkedPhone = '') {
    const phone = checkedPhone || normalizeOmanPhone(this.els.phone.value);
    if (!phone || normalizeOmanPhone(this.els.phone.value) !== phone) return;
    this.state.blocked = true;
    this.state.blockedPhone = phone;
    this.state.phoneChecked = '';
    this.els.submit.disabled = true;
    this.els.submit.hidden = true;
    this.els.blockedActions.hidden = false;
    this.els.onlineCheckout.href = this.safeCheckoutUrl(checkoutUrl);
    this.showAlert(this.t('blacklisted'));
    this.syncTriggers();
  }

  clearBlockedPhone() {
    this.state.blocked = false;
    this.state.blockedPhone = '';
    this.els.submit.hidden = false;
    this.els.submit.disabled = this.state.submitting || this.hasUnsupportedItems();
    this.els.blockedActions.hidden = true;
    this.clearAlert();
    this.syncTriggers();
  }

  safeCheckoutUrl(value) {
    const fallback = new URL(this.cartUrl('checkout'), window.location.origin).href;
    if (!value) return fallback;
    try {
      const url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.href : fallback;
    } catch (_) { return fallback; }
  }

  async openMap() {
    this.els.mapPanel.hidden = false;
    this.els.mapStatus.textContent = this.t('locating');
    // Safari can suppress or delay the permission prompt when geolocation is
    // requested only after an awaited third-party map script. Start the native
    // request synchronously from the customer's click and load the map beside it.
    const locationPromise = this.state.location?.valid
      ? Promise.resolve(null)
      : this.requestBrowserLocation();
    try {
      const L = await loadLeaflet();
      if (!this.state.map) this.createMap(L);
      window.setTimeout(() => this.state.map.invalidateSize(), 60);
      if (this.state.location?.valid) {
        this.state.map.setView([this.state.location.lat, this.state.location.lng], 17);
        return;
      }
      const location = await locationPromise;
      if (location) {
        this.setMapPosition(location.lat, location.lng, location.accuracy, location.source);
      }
    } catch (_) {
      this.els.mapStatus.textContent = this.t('mapLoadError');
    }
  }

  createMap(L) {
    const map = L.map(this.els.mapCanvas, { zoomControl: true, attributionControl: true });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);
    map.setView(OMAN_CENTER, 6);
    map.on('click', (event) => this.setMapPosition(event.latlng.lat, event.latlng.lng, null, 'map'));
    this.state.map = map;
  }

  requestBrowserLocation() {
    if (!navigator.geolocation) {
      this.els.mapStatus.textContent = this.t('geolocationUnavailable');
      return Promise.resolve(null);
    }
    return new Promise((resolve) => {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy,
          source: 'gps'
        }),
        (error) => {
          const errorCode = Number(error?.code);
          const messageKey = errorCode === 1
            ? 'geolocationDenied'
            : errorCode === 3
              ? 'geolocationTimeout'
              : 'geolocationUnavailable';
          this.els.mapStatus.textContent = this.t(messageKey);
          resolve(null);
        },
        { enableHighAccuracy: false, timeout: 20000, maximumAge: 60000 }
      );
    });
  }

  async locateFromBrowser() {
    this.els.mapStatus.textContent = this.t('locating');
    const locationPromise = this.requestBrowserLocation();
    try {
      const L = await loadLeaflet();
      if (!this.state.map) this.createMap(L);
      window.setTimeout(() => this.state.map.invalidateSize(), 60);
      const location = await locationPromise;
      if (location) {
        this.setMapPosition(location.lat, location.lng, location.accuracy, location.source);
      }
    } catch (_) {
      this.els.mapStatus.textContent = this.t('mapLoadError');
    }
  }

  setMapPosition(lat, lng, accuracy, source) {
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !this.state.map) return;
    if (!this.isRoughlyInsideOman(lat, lng)) {
      this.state.location = { lat, lng, accuracy, source, valid: false };
      this.els.latitude.value = '';
      this.els.longitude.value = '';
      this.els.mapStatus.textContent = this.t('outsideOman');
      this.placeMarker(lat, lng);
      return;
    }
    this.state.location = { lat, lng, accuracy, source, valid: true };
    this.els.latitude.value = lat.toFixed(6);
    this.els.longitude.value = lng.toFixed(6);
    this.placeMarker(lat, lng);
    this.state.map.setView([lat, lng], Math.max(this.state.map.getZoom(), 16));
    this.reverseGeocode(lat, lng);
  }

  placeMarker(lat, lng) {
    const L = window.L;
    if (!L) return;
    if (!this.state.marker) {
      const icon = L.divIcon({
        className: 'bt-cod-map-pin-wrap',
        html: '<span class="bt-cod-map-pin" aria-hidden="true"></span>',
        iconSize: [30, 30], iconAnchor: [15, 30]
      });
      this.state.marker = L.marker([lat, lng], { draggable: true, icon }).addTo(this.state.map);
      this.state.marker.on('dragend', () => {
        const point = this.state.marker.getLatLng();
        this.setMapPosition(point.lat, point.lng, null, 'map');
      });
    } else {
      this.state.marker.setLatLng([lat, lng]);
    }
  }

  isRoughlyInsideOman(lat, lng) {
    return lat >= 16.2 && lat <= 26.7 && lng >= 51.7 && lng <= 60.0;
  }

  async reverseGeocode(lat, lng) {
    const sequence = ++this.state.reverseSequence;
    this.els.mapStatus.textContent = this.t('locating');
    try {
      if (!(await this.ensureEligibilityFresh())) throw new Error('ELIGIBILITY_EXPIRED');
      const result = await this.api('reverse-geocode', {
        shop: this.dataset.shopDomain || '',
        eligibilityToken: this.state.eligibilityToken,
        lat,
        lng,
        language: this.lang
      }, 9000);
      if (sequence !== this.state.reverseSequence) return;
      this.state.quoteToken = '';
      const wilaya = findWilaya(result?.wilayaKey) || findWilaya(result?.wilaya) ||
        manualWilayaRecord(result?.wilaya);
      this.setWilayaField(this.els.wilaya, this.els.wilayaKey, wilaya, { notify: true });
      const address = stripOmanCountry(
        String(result?.address || '').slice(0, 300),
        this.lang === 'ar' ? '، ' : ', '
      );
      this.settingAddressFromMap = true;
      this.els.address.value = address;
      this.els.address.setCustomValidity('');
      this.els.address.dispatchEvent(new Event('input', { bubbles: true }));
      this.els.address.dispatchEvent(new Event('change', { bubbles: true }));
      this.settingAddressFromMap = false;
      this.state.location.wilayaCode = wilaya?.code || '';
      this.state.location.mapUrl = String(result?.mapUrl || '')
        || `https://www.openstreetmap.org/?mlat=${lat.toFixed(6)}&mlon=${lng.toFixed(6)}#map=17/${lat.toFixed(6)}/${lng.toFixed(6)}`;
      this.els.mapStatus.textContent = address ? this.t('locationSelected') : this.t('locationManual');
    } catch (error) {
      if (sequence !== this.state.reverseSequence) return;
      this.state.location.valid = false;
      this.state.location.mapUrl = '';
      this.els.latitude.value = '';
      this.els.longitude.value = '';
      if (error.code === 'LOCATION_OUTSIDE_OMAN') {
        this.els.mapStatus.textContent = this.t('outsideOman');
      } else {
        this.els.mapStatus.textContent = this.t('locationManual');
      }
    }
  }

  orderLines() {
    return (this.state.cart?.items || []).map((item) => ({
      variantId: Number(item.variant_id),
      quantity: Number(item.quantity)
    }));
  }

  setWilayaField(input, keyInput, wilaya, { notify = false } = {}) {
    if (!input) return;
    const record = wilaya ? (findWilaya(wilaya.code || wilaya) || wilaya) : null;
    if (input.tagName === 'SELECT') {
      input.value = record?.code || '';
    } else {
      input.value = record ? (this.lang === 'ar' ? record.ar : record.en) : '';
    }
    if (keyInput) keyInput.value = record?.code || '';
    input.setCustomValidity('');
    if (notify) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  selectedWilaya(
    input = this.els.wilaya,
    keyInput = this.els.wilayaKey,
    addressInput = input === this.els.changeWilaya ? this.els.changeAddress : this.els.address
  ) {
    if (!input) return { code: '', ar: '', en: '', text: '', manual: '', matched: false };
    if (input.tagName === 'SELECT') {
      const option = input.selectedOptions[0];
      const record = findWilaya(input.value) || (
        input.value
          ? { code: input.value, ar: option?.dataset.ar || '', en: option?.dataset.en || '' }
          : null
      );
      return {
        code: record?.code || '',
        ar: record?.ar || '',
        en: record?.en || '',
        text: option?.textContent?.trim() || '',
        manual: '',
        matched: Boolean(record?.code)
      };
    }

    const text = String(input.value || '').trim();
    const record = findWilaya(text) || (!text ? findWilaya(keyInput?.value) : null);
    const manual = !record
      ? (manualWilayaRecord(text) || wilayaFromAddress(addressInput?.value))
      : null;
    const selected = record || manual;
    return {
      code: selected?.code || '',
      ar: selected?.ar || '',
      en: selected?.en || '',
      text,
      manual: record ? '' : text,
      matched: Boolean(selected)
    };
  }

  async submitOrder(event) {
    event.preventDefault();
    if (this.state.submitting || this.state.completed || this.state.blocked) return;
    this.clearAlert();
    if (this.hasUnsupportedItems()) {
      this.showAlert(this.t('unsupportedCart'));
      return;
    }
    const delivery = this.validateDeliveryFields(
      this.els.wilaya,
      this.els.wilayaKey,
      this.els.address
    );
    if (!this.els.form.checkValidity()) {
      this.els.form.reportValidity();
      this.showAlert(this.t('requiredFields'));
      return;
    }
    const phone = normalizeOmanPhone(this.els.phone.value);
    if (!phone) {
      this.showAlert(this.t('invalidPhone'));
      this.els.phone.focus();
      return;
    }
    if (!(await this.checkPhone())) return;

    try {
      const latestCart = await this.fetchCart();
      if (this.cartSignature(latestCart) !== this.cartSignature()) {
        this.state.cart = latestCart;
        this.state.quote = null;
        this.state.quoteToken = '';
        this.state.appliedCoupon = '';
        this.renderCart();
        this.showAlert(this.t('cartChanged'));
        return;
      }
    } catch (_) {
      this.showAlert(this.t('networkError'));
      return;
    }

    this.setSubmitting(true);
    this.showAlert(this.t('processing'), 'success');
    if (!(await this.applyCoupon({ forOrder: true }))) {
      this.setSubmitting(false);
      return;
    }

    const wilaya = delivery.wilaya;
    if (!wilaya.matched || !wilaya.code) {
      this.setSubmitting(false);
      this.els.address.setCustomValidity(this.t('requiredFields'));
      this.els.address.reportValidity();
      this.showAlert(this.t('requiredFields'));
      return;
    }
    const fingerprint = [
      this.cartSignature(), this.els.name.value.trim(), phone, wilaya.code,
      this.els.address.value.trim(), this.state.appliedCoupon
    ].join('|');
    if (this.state.idempotencyFingerprint !== fingerprint) {
      this.state.idempotencyFingerprint = fingerprint;
      this.state.idempotencyKey = makeIdempotencyKey();
    }

    const location = this.state.location?.valid ? this.state.location : null;
    const submittedOrder = {
      name: this.els.name.value.trim(),
      address: this.els.address.value.trim(),
      wilayaKey: wilaya.code,
      wilaya: (this.lang === 'ar' ? wilaya.ar : wilaya.en) || wilaya.ar || wilaya.en || wilaya.code,
      phone,
      total: this.state.quote?.exact?.total ||
        (this.state.quote ? this.moneyValue(this.state.quote.total) : this.moneyValue(this.calculatePreview().total))
    };

    try {
      if (!(await this.ensureEligibilityFresh())) {
        const denied = new Error('COD_ELIGIBILITY_REQUIRED');
        denied.code = 'COD_ELIGIBILITY_REQUIRED';
        throw denied;
      }
      const result = await this.api('orders', {
        shop: this.dataset.shopDomain || '',
        eligibilityToken: this.state.eligibilityToken,
        language: this.lang,
        storefrontPath: window.location.pathname,
        name: this.els.name.value.trim(),
        phone: `+968${phone}`,
        email: this.customerEmail || undefined,
        address: this.els.address.value.trim(),
        wilaya: wilaya.code,
        items: this.orderLines(),
        lat: location?.lat,
        lng: location?.lng,
        mapUrl: location?.mapUrl || '',
        discountCode: this.state.appliedCoupon,
        quoteToken: this.state.quoteToken,
        expectedTotal: this.state.quote?.exact?.total ||
          (this.state.quote ? this.moneyValue(this.state.quote.total) : undefined),
        idempotencyKey: this.state.idempotencyKey
      }, 45000);

      if (!result?.success) {
        const error = new Error(result?.message || 'ORDER_FAILED');
        error.code = result?.code || 'ORDER_FAILED';
        error.payload = result;
        throw error;
      }
      this.state.completed = true;
      this.showSuccess(result, submittedOrder);
      void this.clearCartAfterSuccess();
    } catch (error) {
      if (error.code === 'COD_BLACKLISTED' || error.payload?.code === 'COD_BLACKLISTED') {
        this.setSubmitting(false);
        this.handleBlocked(error.payload?.checkoutUrl, phone);
        return;
      }
      if (['COD_NOT_AVAILABLE_IN_COUNTRY', 'COD_ELIGIBILITY_REQUIRED'].includes(error.code)) {
        this.setEligible(false);
        this.showAlert(this.t('countryDenied'));
      } else if (error.code === 'QUOTE_CHANGED') {
        this.state.quote = null;
        this.state.quoteToken = '';
        this.state.appliedCoupon = '';
        this.renderSummary();
        this.showAlert(this.t('cartChanged'));
      } else if (['PRODUCT_UNAVAILABLE', 'INSUFFICIENT_INVENTORY'].includes(error.code)) {
        this.showAlert(this.t('outOfStock'));
      } else if (['INVALID_DISCOUNT_CODE', 'DISCOUNT_CODE_NOT_APPLIED'].includes(error.code)) {
        this.showAlert(this.t('couponInvalid'));
      } else if (['INVALID_WILAYA', 'ADDRESS_REQUIRED', 'ADDRESS_REQUIRED_MUSCAT'].includes(error.code)) {
        this.showAlert(this.t('requiredFields'));
      } else {
        this.showAlert(this.t('orderError'));
      }
      this.setSubmitting(false);
    }
  }

  setSubmitting(value) {
    this.state.submitting = Boolean(value);
    this.els.submit.disabled = this.state.submitting;
    this.els.couponApply.disabled = this.state.submitting;
    this.els.form.setAttribute('aria-busy', String(this.state.submitting));
    this.setClockLoading('submit', this.state.submitting);
    if (this.els.submitSpinner && !this.els.submitSpinner.hasAttribute('data-bt-clock-loader')) {
      this.els.submitSpinner.hidden = !this.state.submitting;
    }
    if (this.state.submitting) this.els.submitLabel.textContent = this.t('processing');
    else this.renderSummary();
  }

  async clearCartAfterSuccess() {
    try {
      await fetch(this.cartUrl('cart/clear.js'), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: '{}'
      });
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (_) { /* The order exists; never resubmit it because clearing failed. */ }
  }

  showSuccess(result, submittedOrder = {}) {
    this.setSubmitting(false);
    this.setClockLoading('cart', false);
    this.setClockLoading('coupon', false);
    this.setClockLoading('contact', false);
    this.els.content.hidden = true;
    this.els.loading.hidden = true;
    this.els.success.hidden = false;
    this.els.main.scrollTop = 0;
    this.els.title.textContent = this.t('successHeader');

    const rawOrder = String(result.orderName || result.orderNumber || '').trim();
    const order = rawOrder.replace(/^#\s*/, '') || rawOrder || '—';
    const name = String(submittedOrder.name || '').trim() || '—';
    const phone = normalizeOmanPhone(submittedOrder.phone || result.phone || '');
    const currencyCandidate = String(result.currency || 'OMR').trim().toUpperCase();
    const currency = /^[A-Z]{3}$/.test(currencyCandidate) ? currencyCandidate : 'OMR';
    const totalAmount = normalizeMoneyDecimal(result.total) ||
      normalizeMoneyDecimal(submittedOrder.total) || '0.000';
    const totalText = `${currency} ${totalAmount}`;
    const wilayaRecord = findWilaya(submittedOrder.wilayaKey || submittedOrder.wilaya);
    const wilaya = wilayaRecord
      ? (this.lang === 'ar' ? wilayaRecord.ar : wilayaRecord.en)
      : String(submittedOrder.wilaya || '').trim();
    const streetAddress = String(submittedOrder.address || '').trim();
    const displayAddress = [wilaya, streetAddress].filter(Boolean).join('، ') || '—';

    this.state.phoneChangeToken = String(
      result.contactChangeToken || result.phoneChangeToken || result.contactCorrectionToken || ''
    ).trim();
    this.state.phoneChangeComplete = false;
    this.state.successSnapshot = {
      name,
      order,
      address: streetAddress,
      wilaya,
      wilayaKey: wilayaRecord?.code || String(submittedOrder.wilayaKey || ''),
      displayAddress,
      phone,
      totalText
    };

    this.els.successMessage.textContent = this.t('successText', { name });
    this.els.successName.textContent = name;
    this.els.successOrder.textContent = order;
    this.els.successAddress.textContent = displayAddress;
    this.els.successPhone.textContent = this.formatOmanPhone(phone);
    this.els.successTotal.textContent = totalText;
    this.els.changePhone.value = phone;
    this.setWilayaField(this.els.changeWilaya, this.els.changeWilayaKey, wilayaRecord);
    if (this.els.changeAddress) this.els.changeAddress.value = streetAddress;
    this.clearDeliveryValidity(this.els.changeWilaya, this.els.changeAddress);
    this.els.changePhoneForm.hidden = true;
    this.els.changePhoneToggles.forEach((button) => {
      button.hidden = !this.state.phoneChangeToken;
      button.setAttribute('aria-expanded', 'false');
    });
    this.els.changePhone.disabled = false;
    this.els.changePhoneSave.hidden = false;
    this.els.changePhoneCancelLabel.textContent = this.t('cancel');
    this.clearPhoneChangeAlert();
    this.updateManualWhatsAppUrl();

    const redirect = this.safeResultUrl(result.redirectUrl);
    if (redirect) {
      this.els.successLink.href = redirect;
      this.els.successLink.textContent = this.t('viewOrder');
      this.els.successLink.hidden = false;
    } else {
      this.els.successLink.hidden = true;
    }
    this.startSuccessCountdown();
    this.els.success.querySelector('h3').focus({ preventScroll: true });
  }

  formatOmanPhone(value) {
    const phone = normalizeOmanPhone(value);
    return phone ? `+968 ${phone}` : '—';
  }

  updateManualWhatsAppUrl() {
    const snapshot = this.state.successSnapshot;
    if (!snapshot) return;
    const messageKey = 'manualWhatsAppText';
    const text = this.t(messageKey, {
      order: snapshot.order,
      total: snapshot.totalText,
      phone: this.formatOmanPhone(snapshot.phone),
      name: snapshot.name,
      address: snapshot.displayAddress
    });
    const params = new URLSearchParams({
      phone: '96876615010',
      text,
      type: 'phone_number',
      app_absent: '0'
    });
    this.els.manualWhatsApp.href = `https://api.whatsapp.com/send/?${params.toString()}`;
  }

  startSuccessCountdown() {
    this.clearSuccessCountdown();
    this.state.watixStatus = '';
    this.state.watixStatusChecking = false;
    this.setClockLoading('countdown', true);
    const durationSeconds = 20;
    const duration = durationSeconds * 1000;
    const startedAt = Date.now();
    const deadline = startedAt + duration;
    this.els.manualConfirmation.hidden = true;
    this.els.manualWhatsAppLabel.textContent = this.t('manualConfirm');
    this.els.watixStatus.hidden = true;
    this.els.watixStatus.textContent = '';
    this.els.watixStatus.removeAttribute('data-kind');
    this.els.confirmation.removeAttribute('data-ready');
    this.els.confirmationProgress.setAttribute('aria-valuenow', '0');
    this.els.confirmationProgressBar.style.width = '0%';

    const update = () => {
      const now = Date.now();
      const remaining = Math.max(0, deadline - now);
      const seconds = Math.max(0, Math.ceil(remaining / 1000));
      const elapsedSeconds = Math.min(durationSeconds, Math.max(0, (now - startedAt) / 1000));
      const progress = Math.min(100, (elapsedSeconds / durationSeconds) * 100);
      this.els.countdownSeconds.textContent = String(seconds);
      this.els.confirmationMessage.textContent = this.t('confirmationCountdown', { seconds });
      this.els.confirmationProgress.setAttribute('aria-valuenow', String(Math.floor(elapsedSeconds)));
      this.els.confirmationProgressBar.style.width = `${progress}%`;
      if (remaining <= 0) this.revealManualConfirmation();
    };

    update();
    this.successCountdownTimer = window.setInterval(update, 250);
    this.successCountdownRevealTimer = window.setTimeout(() => {
      this.revealManualConfirmation();
    }, duration + 50);
    this.watixStatusTimer = window.setInterval(() => {
      void this.checkWatixStatus();
    }, 2500);
  }

  async checkWatixStatus() {
    if (
      this.state.watixStatusChecking ||
      !this.state.completed ||
      !this.state.phoneChangeToken ||
      this.state.watixStatus
    ) return;

    const token = this.state.phoneChangeToken;
    this.state.watixStatusChecking = true;
    try {
      const result = await this.api('orders/whatsapp-status', { token }, 5500);
      if (
        !this.state.completed ||
        token !== this.state.phoneChangeToken ||
        this.state.watixStatus
      ) return;
      if (result?.status === 'SENT' || result?.status === 'NO_WHATSAPP') {
        this.showWatixStatus(result.status);
      }
    } catch (_) {
      // Watix is an optional speed-up. The normal 20-second fallback remains available.
    } finally {
      this.state.watixStatusChecking = false;
    }
  }

  showWatixStatus(status) {
    if (status !== 'SENT' && status !== 'NO_WHATSAPP') return;
    this.state.watixStatus = status;
    this.els.confirmationMessage.textContent = this.t('confirmationReady');
    this.clearSuccessCountdown();
    this.els.countdownSeconds.textContent = '';
    this.els.confirmationProgress.setAttribute('aria-valuenow', '20');
    this.els.confirmationProgressBar.style.width = '100%';
    this.els.confirmation.setAttribute('data-ready', 'true');
    this.els.watixStatus.dataset.kind = status === 'SENT' ? 'sent' : 'no-whatsapp';
    this.els.watixStatus.textContent = this.t(
      status === 'SENT' ? 'whatsappSentAction' : 'whatsappNoAccount'
    );
    this.els.watixStatus.hidden = false;
    this.els.manualWhatsAppLabel.textContent = this.t(
      status === 'NO_WHATSAPP' ? 'changeWhatsappManually' : 'manualConfirm'
    );
    this.els.manualConfirmation.hidden = false;
    this.updateManualWhatsAppUrl();
  }

  revealManualConfirmation() {
    this.clearSuccessCountdown();
    this.state.watixStatus = '';
    this.els.countdownSeconds.textContent = '';
    this.els.confirmationMessage.textContent = this.t('confirmationReady');
    this.els.confirmationProgress.setAttribute('aria-valuenow', '20');
    this.els.confirmationProgressBar.style.width = '100%';
    this.els.confirmation.setAttribute('data-ready', 'true');
    this.els.watixStatus.hidden = true;
    this.els.watixStatus.textContent = '';
    this.els.watixStatus.removeAttribute('data-kind');
    this.els.manualWhatsAppLabel.textContent = this.t('manualConfirm');
    this.els.manualConfirmation.hidden = false;
    this.updateManualWhatsAppUrl();
  }

  clearSuccessCountdown() {
    if (this.successCountdownTimer) window.clearInterval(this.successCountdownTimer);
    if (this.successCountdownRevealTimer) window.clearTimeout(this.successCountdownRevealTimer);
    if (this.watixStatusTimer) window.clearInterval(this.watixStatusTimer);
    this.successCountdownTimer = null;
    this.successCountdownRevealTimer = null;
    this.watixStatusTimer = null;
    this.setClockLoading('countdown', false);
  }

  togglePhoneChange(show, mode = 'phone') {
    const shouldOpen = Boolean(show && this.state.phoneChangeToken);
    this.els.changePhoneForm.hidden = !shouldOpen;
    this.els.changePhoneForm.inert = !shouldOpen;
    this.els.changePhoneForm.setAttribute('aria-hidden', String(!shouldOpen));
    this.els.changePhoneToggles.forEach((button) => {
      const active = shouldOpen && button.dataset.btEditMode === mode;
      button.setAttribute('aria-expanded', String(active));
    });
    if (this.els.changePhoneField) this.els.changePhoneField.hidden = shouldOpen && mode === 'address';
    if (this.els.changeAddressField) this.els.changeAddressField.hidden = shouldOpen && mode === 'phone';
    if (!shouldOpen) {
      this.clearPhoneChangeAlert();
      return;
    }
    this.els.changePhone.value = this.state.successSnapshot?.phone || '';
    const snapshotWilaya = findWilaya(
      this.state.successSnapshot?.wilayaKey || this.state.successSnapshot?.wilaya
    );
    this.setWilayaField(this.els.changeWilaya, this.els.changeWilayaKey, snapshotWilaya);
    if (this.els.changeAddress) {
      this.els.changeAddress.value = this.state.successSnapshot?.address || '';
    }
    this.clearDeliveryValidity(this.els.changeWilaya, this.els.changeAddress);
    const focusTarget = mode === 'address' ? this.els.changeAddress : this.els.changePhone;
    window.requestAnimationFrame(() => focusTarget?.focus({ preventScroll: true }));
  }

  async submitPhoneChange(event) {
    event.preventDefault();
    if (this.state.phoneChanging || !this.state.phoneChangeToken) return;
    const phone = normalizeOmanPhone(this.els.changePhone.value);
    if (!phone) {
      this.showPhoneChangeAlert(this.t('invalidPhone'));
      this.els.changePhone.focus();
      return;
    }
    const hasDeliveryFields = Boolean(this.els.changeWilaya || this.els.changeAddress);
    const delivery = hasDeliveryFields
      ? this.validateDeliveryFields(
          this.els.changeWilaya,
          this.els.changeWilayaKey,
          this.els.changeAddress
        )
      : null;
    if (hasDeliveryFields && !delivery.valid) {
      this.els.changePhoneForm.reportValidity();
      this.showPhoneChangeAlert(this.t('requiredFields'));
      return;
    }

    const currentWilayaValue = this.state.successSnapshot?.wilayaKey || this.state.successSnapshot?.wilaya;
    const currentWilayaKey = findWilaya(currentWilayaValue)?.code || String(currentWilayaValue || '').trim();
    const samePhone = phone === this.state.successSnapshot?.phone;
    const sameWilaya = !hasDeliveryFields || delivery.wilaya.code === currentWilayaKey;
    const sameAddress = !hasDeliveryFields || delivery.address === String(
      this.state.successSnapshot?.address || ''
    ).trim();
    if (samePhone && sameWilaya && sameAddress) {
      this.showPhoneChangeAlert(this.translatedOr('sameDetails', 'samePhone'));
      return;
    }
    const updatesContact = !(sameWilaya && sameAddress);

    this.setPhoneChanging(true);
    this.clearPhoneChangeAlert();
    try {
      const endpoint = updatesContact ? 'orders/update-contact' : 'orders/update-phone';
      const payload = {
        token: this.state.phoneChangeToken,
        phone,
        language: this.lang
      };
      if (updatesContact) {
        payload.wilaya = delivery.wilaya.code;
        payload.address = delivery.address;
      }
      const result = await this.api(endpoint, payload, 35000);
      if (result?.ok !== true && result?.success !== true) {
        const error = new Error(result?.message || 'CONTACT_UPDATE_FAILED');
        error.code = result?.code || 'CONTACT_UPDATE_FAILED';
        throw error;
      }

      const confirmedPhone = normalizeOmanPhone(result.phone || '') || phone;
      const confirmedWilaya = updatesContact
        ? (findWilaya(result.wilayaKey) || findWilaya(result.wilaya) || delivery.wilaya)
        : findWilaya(this.state.successSnapshot?.wilayaKey || this.state.successSnapshot?.wilaya);
      const confirmedAddress = updatesContact
        ? String(result.address ?? delivery.address).trim()
        : String(this.state.successSnapshot?.address || '').trim();
      const confirmedWilayaLabel = confirmedWilaya
        ? (this.lang === 'ar' ? confirmedWilaya.ar : confirmedWilaya.en)
        : String(this.state.successSnapshot?.wilaya || '').trim();
      const displayAddress = [confirmedWilayaLabel, confirmedAddress].filter(Boolean).join('، ') || '—';
      this.state.successSnapshot.phone = confirmedPhone;
      this.state.successSnapshot.wilaya = confirmedWilayaLabel;
      this.state.successSnapshot.wilayaKey = confirmedWilaya?.code || '';
      this.state.successSnapshot.address = confirmedAddress;
      this.state.successSnapshot.displayAddress = displayAddress;
      this.state.phoneChangeToken = '';
      this.state.phoneChangeComplete = true;
      this.els.changePhone.value = confirmedPhone;
      this.els.successPhone.textContent = this.formatOmanPhone(confirmedPhone);
      this.els.successAddress.textContent = displayAddress;
      this.setWilayaField(this.els.changeWilaya, this.els.changeWilayaKey, confirmedWilaya);
      if (this.els.changeAddress) this.els.changeAddress.value = confirmedAddress;
      this.els.changePhoneToggles.forEach((button) => { button.hidden = true; });
      this.els.changePhoneSave.hidden = true;
      this.els.changePhoneCancelLabel.textContent = this.translatedOr('closeDetails', 'closePhoneChange');
      this.showPhoneChangeAlert(
        updatesContact
          ? this.translatedOr('detailsUpdated', 'phoneUpdated')
          : this.t('phoneUpdated'),
        'success'
      );
      this.updateManualWhatsAppUrl();
      this.setPhoneChanging(false);
      this.revealManualConfirmation();
    } catch (error) {
      const serverMessage = String(error?.payload?.message || '').trim();
      const message = error.code === 'COD_BLACKLISTED'
        ? this.t('blacklisted')
        : error.code === 'INVALID_PHONE'
          ? this.t('invalidPhone')
          : error.code === 'INVALID_WILAYA'
            ? this.translatedOr('invalidWilaya', 'requiredFields')
            : ['ADDRESS_REQUIRED', 'ADDRESS_REQUIRED_MUSCAT'].includes(error.code)
              ? this.translatedOr('addressRequiredMuscat', 'requiredFields')
              : serverMessage || (updatesContact
                ? this.translatedOr('detailsUpdateError', 'phoneUpdateError')
                : this.t('phoneUpdateError'));
      this.showPhoneChangeAlert(message);
    } finally {
      this.setPhoneChanging(false);
    }
  }

  setPhoneChanging(value) {
    this.state.phoneChanging = Boolean(value);
    this.els.changePhone.disabled = this.state.phoneChanging || this.state.phoneChangeComplete;
    if (this.els.changeWilaya) {
      this.els.changeWilaya.disabled = this.state.phoneChanging || this.state.phoneChangeComplete;
    }
    if (this.els.changeAddress) {
      this.els.changeAddress.disabled = this.state.phoneChanging || this.state.phoneChangeComplete;
    }
    this.els.changePhoneSave.disabled = this.state.phoneChanging;
    this.els.changePhoneCancel.disabled = this.state.phoneChanging;
    this.els.changePhoneToggles.forEach((button) => {
      button.disabled = this.state.phoneChanging;
    });
    this.setClockLoading('contact', this.state.phoneChanging);
    if (this.els.changePhoneSpinner && !this.els.changePhoneSpinner.hasAttribute('data-bt-clock-loader')) {
      this.els.changePhoneSpinner.hidden = !this.state.phoneChanging;
    }
    this.els.changePhoneSaveLabel.textContent = this.state.phoneChanging
      ? this.translatedOr(
          this.els.changeWilaya || this.els.changeAddress ? 'updatingDetails' : 'updatingPhone',
          'updatingPhone'
        )
      : this.translatedOr(
          this.els.changeWilaya || this.els.changeAddress ? 'saveDetails' : 'savePhone',
          'savePhone'
        );
  }

  showPhoneChangeAlert(message, kind = 'error') {
    this.els.changePhoneAlert.textContent = String(message || '');
    this.els.changePhoneAlert.dataset.kind = kind;
    this.els.changePhoneAlert.hidden = !message;
  }

  clearPhoneChangeAlert() {
    this.els.changePhoneAlert.textContent = '';
    this.els.changePhoneAlert.removeAttribute('data-kind');
    this.els.changePhoneAlert.hidden = true;
  }

  safeResultUrl(value) {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      const apiOrigin = this.apiBase ? new URL(this.apiBase).origin : '';
      return [window.location.origin, apiOrigin].includes(url.origin) && ['http:', 'https:'].includes(url.protocol)
        ? url.href : '';
    } catch (_) { return ''; }
  }

  showAlert(message, kind = 'error') {
    this.els.alert.textContent = String(message || '');
    this.els.alert.dataset.kind = kind;
    this.els.alert.hidden = !message;
  }

  clearAlert() {
    this.els.alert.textContent = '';
    this.els.alert.removeAttribute('data-kind');
    this.els.alert.hidden = true;
  }

  async api(path, payload, timeout = 10000) {
    if (!this.apiBase) throw new Error('API_BASE_MISSING');
    const controller = new AbortController();
    this.requestControllers.add(controller);
    const timer = window.setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(`${this.apiBase}/${String(path).replace(/^\/+/, '')}`, {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Hala-Locale': this.lang,
          ...(this.state.eligibilityToken
            ? { 'X-COD-Eligibility': this.state.eligibilityToken }
            : {})
        },
        body: JSON.stringify(payload || {}), signal: controller.signal
      });
      const text = await response.text();
      const data = safeJson(text) || {};
      if (!response.ok) {
        const error = new Error(data.message || `HTTP_${response.status}`);
        error.code = data.code || `HTTP_${response.status}`;
        error.payload = data;
        throw error;
      }
      return data;
    } finally {
      window.clearTimeout(timer);
      this.requestControllers.delete(controller);
    }
  }
}

if (!customElements.get('bt-cod-form')) {
  customElements.define('bt-cod-form', BtCodForm);
}
